import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn, RaikoGridThreeColumn, RaikoMobileInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useState} from "react";
import {ResidencesManagerService} from "../../../serverService/residencesManagerService/ResidencesManagerService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import LanguageSelector from "../../../component/languageSelector/LanguageSelector";

export default function ResidenceManagerBasicInfo({residenceManagerId}) {



    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new ResidencesManagerService()

    const [languageId, setLanguageId] = useState();

    const [clerkFullName, setClerkFullName] = useState("")
    const [userName, setUserName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [createdBy, setCreatedBy] = useState("")
    const [createDate, setCreateDate] = useState("")

    function handleGetInfo(languageCode = languageId) {
        loading.show()
        setClerkFullName("")

        service.getClerkInfo(residenceManagerId, languageCode)
            .then(response => {

                setClerkFullName(response.metaData.fullName)
                setUserName(response.username)
                setPhoneNumber(response.phoneNumber)

                setCreatedBy(response.createdBy)
                setCreateDate(convertUniversalDateTimeToPersianDateTime(response.createdAt))

            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateClerkInfo() {
        loading.show()
        service.updateClerkInfo(residenceManagerId, languageId, clerkFullName, phoneNumber)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <LanguageSelector languageId={languageId} setLanguageId={setLanguageId} handleGetInfo={handleGetInfo}/>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton={true}
                    actionButtonOnclick={handleUpdateClerkInfo}
                >
                    <RaikoGridThreeColumn>
                        <RaikoSimpleInputOutlined
                            labelText={"نام و نام خانوادگی"}
                            value={clerkFullName}
                            setValue={setClerkFullName}
                        />
                        <RaikoMobileInputOutlined
                            labelText={"شماره تلفن همراه"}
                            value={phoneNumber}
                            setValue={setPhoneNumber}
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"نام کاربری"}
                            value={userName}
                            setValue={setUserName}
                            disabled={true}
                        />
                    </RaikoGridThreeColumn>

                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createDate}/>
        </RaikoGridOneColumn>
    )
}